import { Component, Input } from '@angular/core';
import { createComponentValueAccessor } from '@app/shared/utils';

export interface RadioSelectorsConfig<Data = any> {
  isReadOnly: boolean;
  name: string;
  selectedValue?: Data;
  selectors: {
    id: string;
    value: Data;
    text: string;
  }[];
}

@Component({
  standalone: false,
  selector: 'ti-radio-selectors',
  templateUrl: './radio-selectors.component.html',
  styleUrls: ['./radio-selectors.component.sass'],
  providers: [createComponentValueAccessor(RadioSelectorsComponent)],
})
export class RadioSelectorsComponent {
  @Input() config: RadioSelectorsConfig;
  @Input() _styleClass: string;
  public get styleClass(): string {
    return this._styleClass || '';
  }
  @Input() isReadOnly: boolean;

  seed: string;
  private _selectedValue = false;

  set selectedValue(v) {
    this._selectedValue = v;
    this.onChange(v);
  }
  get selectedValue() {
    return this._selectedValue;
  }

  // #region AccessorProps
  onChange: any = () => {};
  onTouch: any = () => {};
  // #endregion

  constructor() {
    // we need this to prevent bugs if there are few instances of this component are active at the same time (it is possible)
    this.seed = Math.random().toString(36).substr(2, 9);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.config) {
      this.config.isReadOnly = isDisabled;
    }
  }

  writeValue(v): void {
    this._selectedValue = v;
  }
}
